import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'yu-time-picker',
  templateUrl: './yu-time-picker.component.html',
  styleUrls: ['./yu-time-picker.component.scss'],
  standalone: false
})
export class YuTimePickerComponent {

  @Input() label: string = '';
  @Input() value: string = '0:00:00';

  @Output() valueChange = new EventEmitter<string>();

  constructor(
    private modalCtrl: ModalController,
  ) {
  }

  /**
   * Abrir modal con el picker selector
   *
   */
  async open(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: YuTimePickerModal,
      componentProps: {
        value: this.value
      },
      cssClass: 'yu-time-picker-modal',
    });

    modal.onDidDismiss().then(({data}) => {
      if (data !== undefined) {
        this.value = data;
        this.valueChange.emit(data);
      }
    });

    await modal.present();
  }

}


@Component({
  selector: 'yu-time-picker-modal',
  templateUrl: './yu-time-picker-modal.html',
  standalone: false
})
export class YuTimePickerModal implements OnInit {

  @Input() value: string = '0:00:00';

  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;

  readonly hoursOptions = Array.from({length: 100}, (_, i) => ({
    text: `${String(i).padStart(2, '0')}h`,
    value: i,
  }));

  readonly minutesOptions = Array.from({length: 60}, (_, i) => ({
    text: `${String(i).padStart(2, '0')}m`,
    value: i,
  }));

  readonly secondsOptions = Array.from({length: 60}, (_, i) => ({
    text: `${String(i).padStart(2, '0')}s`,
    value: i,
  }));

  constructor(
    private modalCtrl: ModalController
  ) {
  }


  ngOnInit(): void {
    const parts = (this.value || '0:00:00').split(':');

    this.hours = Math.max(0, parseInt(parts[0] || '0', 10));
    this.minutes = Math.max(0, Math.min(59, parseInt(parts[1] || '0', 10)));
    this.seconds = Math.max(0, Math.min(59, parseInt(parts[2] || '0', 10)));
  }


  onColumnChange(column: 'hours' | 'minutes' | 'seconds', event: CustomEvent): void {
    const val = Number(event.detail.value) || 0;

    if (column === 'hours') {
      this.hours = val;
      return;
    }

    if (column === 'minutes') {
      this.minutes = val;
      return;
    }

    if (column === 'seconds') {
      this.seconds = val;
      return;
    }
  }


  confirm(): void {
    const duration = `${this.hours}:${String(this.minutes).padStart(2, '0')}:${String(this.seconds).padStart(2, '0')}`;
    this.modalCtrl.dismiss(duration);
  }


  cancel(): void {
    this.modalCtrl.dismiss();
  }

}
